export default "__VITE_ASSET__w18uhxQD__"